import Marionette from "backbone.marionette";
import _ from "lodash";
import $ from "jquery";

import component from "../templates/components";
import modelUtil from "../models/util";

const AvailabilityComponent = Marionette.View.extend({
    template: component.Availability,
    ui: {
        form: "form",
        invalidPopup: ".availability-grid__invalid",
        closePopup: ".availability-grid__invalid-close",
    },
    events: {
        "click @ui.closePopup": "onClosePopup",
    },
    onClosePopup(event) {
        event.preventDefault();

        if (this.options.inModal) {
            this.ui.invalidPopup.fadeOut();
        } else {
            $.modal.close();
        }
    },
    serializeData() {
        return _.extend(
            {
                isApp: !!this.options.isApp,
                prefix: this.options.prefix || "",
                disabled: this.options.disabled || false,
            },
            this.options.data,
        );
    },
    getData() {
        return this.ui.form.serializeHash();
    },
    showInvalidPopup() {
        this.ui.invalidPopup.fadeIn();
    },
    showInvalidModal() {
        this.ui.invalidPopup.modal({
            showClose: false,
            fadeDuration: 350,
            fadeDelay: 0,
        });

        $(".availability-grid__invalid__close").off().on("click", this.onClosePopup.bind(this));
    },
    validate() {
        const data = this.getData();
        const bad = modelUtil.SHIFT_PREFERENCE.DEFINITELY_NOT;

        if (
            data.pref_shift_day == bad &&
            data.pref_shift_swing == bad &&
            data.pref_shift_night == bad
        ) {
            if (this.options.inModal) {
                this.showInvalidPopup();
            } else {
                this.showInvalidModal();
            }
            return false;
        }

        return true;
    },
});

export default AvailabilityComponent;
